import Vue from 'vue'
import App from '../components/App.vue'
Vue.config.productionTip = false

/* eslint-disable no-new */
/* global BUILD_ENV */
console.log(BUILD_ENV)
new Vue({
  el: '#app',
  render: h => h(App),
  components: { App }
})
